import React, { useState, useEffect } from 'react';
import { createCheckoutSession } from '../api/checkout';
import { Box, Typography, Button, Alert, Stack, Paper } from '@mui/material';
import { NoticeModal } from '../components/Modals';

const PaymentFailure = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [redirectUrl, setRedirectUrl] = useState('/');
  const [price_id, setprice_id] = useState(null);
  const [mode, setMode] = useState('payment');
  const [companyId, setCompanyId] = useState(null);
  const [campaignCode, setCampaignCode] = useState(null);
  const [noticeOpen, setNoticeOpen] = useState(false);
  const [noticeMsg, setNoticeMsg] = useState('');

  const showNotice = (msg) => {
    setNoticeMsg(msg);
    setNoticeOpen(true);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const message = params.get('message');
    const redirect = params.get('redirect_url');
    const price = params.get('price_id');
    const modeParam = params.get('mode');
    const urlCompanyId = params.get('company_id');
    const urlCampaignCode = params.get('campaign_code');

    if (message) setErrorMessage(message);
    if (redirect) setRedirectUrl(redirect);
    if (price) setprice_id(price);
    if (modeParam) setMode(modeParam);

    if (urlCompanyId) {
      setCompanyId(urlCompanyId);
    } else {
      const storageCompanyId = localStorage.getItem('company_id');
      if (storageCompanyId) setCompanyId(storageCompanyId);
    }

    if (urlCampaignCode) {
      setCampaignCode(urlCampaignCode);
    } else {
      const storageCampaignCode = localStorage.getItem('campaign_code');
      if (storageCampaignCode) setCampaignCode(storageCampaignCode);
    }

    console.log('PaymentFailure Params:', {
      message,
      redirect,
      price,
      modeParam,
      companyId: urlCompanyId || localStorage.getItem('company_id'),
      campaignCode: urlCampaignCode || localStorage.getItem('campaign_code'),
    });
  }, []);

  const handleRetry = async () => {
    if (!companyId || !price_id || !mode) {
      console.error('再試行に必要な情報が不足しています', {
        companyId,
        price_id,
        mode,
        campaignCode,
      });
      showNotice('再試行に必要な情報が不足しています');
      return;
    }

    try {
      const data = await createCheckoutSession(
        companyId,
        price_id,
        mode,
        campaignCode
      );

      if (data.checkout_url) {
        window.location.href = data.checkout_url;
      } else {
        console.error('checkout_urlがレスポンスに含まれていません:', data);
        showNotice('決済URLの取得に失敗しました');
      }
    } catch (error) {
      console.error('API呼び出しエラー:', error);
      showNotice('再試行中にエラーが発生しました');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        padding: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 500,
          width: '100%',
          borderRadius: 2,
        }}
      >
        <Typography variant="h4" color="error">
          決済失敗
        </Typography>

        <Alert severity="error" sx={{ mb: 3 }}>
          {errorMessage || '決済に失敗しました。もう一度お試しください。'}
        </Alert>

        <Stack direction="column" spacing={2} sx={{ width: '100%' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleRetry}
            size="large"
            sx={{ borderRadius: 2 }}
          >
            再試行
          </Button>

          <Button
            variant="outlined"
            color="primary"
            href={redirectUrl}
            size="large"
            sx={{ borderRadius: 2 }}
          >
            他の支払い方法を選択する
          </Button>
        </Stack>
      </Paper>
      <NoticeModal
        open={noticeOpen}
        message={noticeMsg}
        onClose={() => setNoticeOpen(false)}
      />
    </Box>
  );
};

export default PaymentFailure;
